import $ from 'jquery/src/jquery';
import gsap from "gsap";
import SiteHeader from "../modules/site-header";
import AnimationMagnetic from "../modules/animation-magnetic";
import AnimationMouseLine from "../modules/animation-mouse-line";
import SearchOverlay from "./search-overlay";

export default () => {
    const nodeSelectors = {
        container: '[js-site-nav-mobile="container"]',
        opener: '[js-site-nav-mobile="opener"]',

        background: '[js-site-nav-mobile="background"]',
        illustration: '[js-site-nav-mobile="illustration"]',
    }

    const openNavTl = gsap.timeline({
        paused: true
    });

    const closeNavTl = gsap.timeline({
        paused: true,
    });

    openNavTl.to(document.querySelector(nodeSelectors.container), {display: 'block', duration: 0.01}, 0)
    .to(document.querySelector(nodeSelectors.container), {opacity: 1, duration: 0.01, onComplete: () => {
            AnimationMagnetic().updateRects()
        }}, 0)
    .to(document.querySelector(nodeSelectors.background), {height: '100%', duration: 0.5, ease: "power2.in"}, 0)
    .to(document.querySelector(nodeSelectors.container).querySelectorAll('.content'), {opacity: 1, duration: 0.5, ease: "power2.in"}, 0.5)
    .to(document.querySelector(nodeSelectors.container).querySelectorAll('nav li'), {opacity: 1, duration: 0.5, stagger: 0.1, ease: "power2.in"}, 0.5)
    .to(document.querySelector(nodeSelectors.container).querySelectorAll('.col-title'), {opacity: 1, duration: 0.5, ease: "power2.in"}, 1)
    .to(document.querySelector(nodeSelectors.container).querySelectorAll('.social-media li'), {opacity: 1, duration: 0.5, stagger: 0.1, ease: "power2.in"}, 1)
    .to(document.querySelector(nodeSelectors.container).querySelectorAll('.logos li'), {opacity: 1, duration: 0.5, stagger: 0.1, ease: "power2.in"}, 1)

    closeNavTl.to(document.querySelector(nodeSelectors.container), {opacity: 0, duration: 0.2}, 0)
    .to(document.querySelector(nodeSelectors.container), {display: 'none', duration: 0}, 0.3)

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        $(document).keyup(function(e) {
            if (e.key === "Escape") {
                close();
            }
        });

        $(nodeSelectors.opener).on('click', function () {
            if( $(nodeSelectors.container).hasClass('site-nav-mobile--active') ) {
                close()
            } else {
                open()
            }
        })

        $(nodeSelectors.container + ' .menu-item-has-children').on('click', function (e) {

            let subMenu = $(this).find(' > .sub-menu')

            if( !subMenu.is(':visible') ) {
                e.preventDefault()
            } else {

            }

            subMenu.slideToggle()
        })
    }

    function open() {
        if( !SearchOverlay().isActive() ) {
            openNavTl.timeScale(1).play()
            openNavTl.restart()

            $('body, html').addClass('gl-no-scroll')
            $('body').addClass('body--nav-mobile-is-active')
            $(nodeSelectors.container).addClass('site-nav-mobile--active')
            $(nodeSelectors.opener).addClass('hamburger--active')
            $(nodeSelectors.illustration).addClass('illustration--animate')
            $(SiteHeader().nodeSelectors.container).addClass('site-header--nav-mobile-is-active')
            $(AnimationMouseLine().nodeSelectors.container).addClass('mouse-line--nav-mobile-is-active')
        }
    }

    function close() {
        if( !SearchOverlay().isActive() ) {
            closeNavTl.timeScale(1).play()
            closeNavTl.restart()

            $('body, html').removeClass('gl-no-scroll')
            $('body').removeClass('body--nav-mobile-is-active')
            $(nodeSelectors.container).removeClass('site-nav-mobile--active')
            $(nodeSelectors.opener).removeClass('hamburger--active')
            $(nodeSelectors.illustration).removeClass('illustration--animate')
            $(SiteHeader().nodeSelectors.container).removeClass('site-header--nav-mobile-is-active')
            $(AnimationMouseLine().nodeSelectors.container).removeClass('mouse-line--nav-mobile-is-active')
        }
    }

    function isActive() {
        return $(nodeSelectors.container).is(':visible')
    }

    return Object.freeze({
        init,
        close,
        open,
        nodeSelectors,
        isActive
    })
}